import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { API } from '@const'
import * as utils from '@utils'
import Divider from '@material-ui/core/Divider'
import QRCode from "react-qr-code";

class OtpViewDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'OtpViewDialog')
        }
    }

    state = {
        otpUrl: ''
    }

    componentDidMount() {
        this.queryData()
    }

    queryData() {
        utils.apiRequest(
            'get',
            API.GET_OTP_QRCODE,
            {},
            (data) => {
                this.setState({ otpUrl: data.otp_url })
            },
            () => {
                this.props.closeOtpView()
            },
            true
        )
    }
    render() {
        const { classes } = this.props
        return (
            <Dialog open={true} disableBackdropClick={true}  disableEscapeKeyDown={true}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent className={classes.warpper}>
                    <div className={classes.otpTitle}>{this.t('illustrate')}</div>
                    {this.state.otpUrl && <QRCode
                        style={{width: '100%', maxWidth: '100%', height: 'auto'}}
                        value={this.state.otpUrl}
                        level='Q'
                    />}
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => this.props.closeOtpView()}
                        color="primary">
                        {this.t('close')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

OtpViewDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    auth: PropTypes.object,
    otpBindingSuccess: PropTypes.func,
    compDialogArgs: PropTypes.object,
    closeOtpView: PropTypes.func,
}

const styles = (_theme) => ({
    otpTitle: {
        textAlign: 'center',
        fontSize: '16px',
        paddingBottom: '15px',
    },
    warpper: {
        width: '400px',
    },
})

export default hoc(styles)(OtpViewDialog)
